import { render, staticRenderFns } from "./OurPercentageInput.vue?vue&type=template&id=0a37f7a3&"
import script from "./OurPercentageInput.vue?vue&type=script&lang=js&"
export * from "./OurPercentageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports